import gql from 'graphql-tag';

export const auth0UserFieldsFragment = gql`
  fragment AdminAuth0UserFields on Auth0User {
    _id
    user_id
    email
    email_verified
    phone_number
    phone_verified
    name
    nickname
    picture
    sanity {
      uid
      name
      archived
    }
    last_login
    last_ip
    logins_count
    identities {
      user_id
      provider
      connection
      isSocial
      profileData {
        email
        phone_number
        phone_verified
        email_verified
      }
    }
    created_at
    updated_at
  }
`;
